{
  "hero": {
    "title": "Contact"
  },
  "intro": {
    "text": "Let's collaborate! Whether you need videos, designs, or digital solutions, I'm just a message away. Fill out the form below or contact me directly—I can't wait to hear about your project."
  },
  "form": {
    "title": "Send me a message",
    "fields": {
      "fullName": {
        "label": "Full Name"
      },
      "email": {
        "label": "Email"
      },
      "message": {
        "label": "Message"
      }
    },
    "submit": "Send Message"
  },
  "direct": {
    "title": "Or contact me directly",
    "email": {
      "label": "Email: octavian@khromatik.com",
      "tooltip": "Copy email"
    }
  }
}
